<template>
  <div>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="" prop="companyCode">
        <el-input size="mini" clearable v-model="formInline.t.companyCode" :placeholder="$t('qing-shu-ru-zu-zhi-ji-gou-dai-ma')">
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="companyCode">
        <el-input size="mini" clearable v-model="formInline.t.companyName" :placeholder="$t('qing-shu-ru-gong-si-ming-cheng')">
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="isAvailable">
        <el-select size="mini"
                   clearable
                   v-model="formInline.t.isAvailable"
                   :placeholder="$t('shi-fou-you-xiao')">
          <el-option v-for="item in searchData.yesOrNo"
                     :key="item.value"
                     v-bind:label="item.message"
                     v-bind:value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">{{ $t('deviceControl.empty') }}</el-button>
        <el-button size="mini" type="primary" :loading='loading' icon="el-icon-search" @click="search">{{ $t('deviceControl.search') }}</el-button>
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd()"
                   v-if="checkPermission(['bee:ict:cecCompanyInfo:insert'])">{{ $t('deviceControl.Add') }}
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
              @selection-change="selectChange"
              :data="userData"
              highlight-current-row
              v-loading="loading"
              border
              :element-loading-text="$t('paramMonitor.Loading')"
              style="width: 100%;">
      <af-table-column prop="companyCode" :label="$t('zu-zhi-ji-gou-dai-ma')">
      </af-table-column>
      <af-table-column prop="companyName" :label="$t('gong-si-ming-cheng')">
      </af-table-column>
      <af-table-column prop="operatorName" :label="$t('yun-ying-shang-ming-cheng')" width="250">
      </af-table-column>
      <af-table-column prop="companyUrl" :label="URL">
      </af-table-column>
      <af-table-column prop="state.message"  :label="$t('kai-qi-zhuang-tai')"  width="140" >
        <template slot-scope="scope" v-if="scope.row.isAvailable">
          <el-tooltip :content="scope.row.isAvailable.message" placement="top">
            <el-switch
              v-model="userData[scope.$index].isAvailable.code"
              active-value='Y'
              inactive-value="N"
              active-color="#13ce66"
              disabled
              @click.native="handleSwitch(scope.$index, scope.row)"
            ></el-switch>
          </el-tooltip>
        </template>
      </af-table-column>

      <af-table-column prop="description" :label="$t('paramMonitor.describe')" width="250">
      </af-table-column>
      <af-table-column :label="$t('deviceControl.operation')" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="synchronizeData(scope.$index, scope.row)">{{ $t('tong-bu-shu-ju') }}</el-button>
          <template v-if="checkPermission(['bee:ict:cecCompanyInfo:update'])">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">{{ $t('alaramMonitor.edit') }}</el-button>
          </template>

          <template v-if="checkPermission(['bee:ict:cecCompanyInfo:deleteById'])">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">{{ $t('deviceControl.delete') }}</el-button>
          </template>
        </template>
      </af-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination :child-msg="pageParam" @callFather="callFather"></Pagination>

    <!-- 添加界面 -->
    <AddPage
      :form-visible="addFormVisible"
      :searchData="searchData"
      @closeDialog="closeDialog"
      @afterAdd="afterAdd"
    ></AddPage>

    <!--修改-->
    <UpdatePage
      :form-visible="updateFormVisible"
      :searchData="searchData"
      :selectRowData="selectRowData"
      @closeDialog="closeDialog"
      @afterUpdate="afterUpdate"
    ></UpdatePage>

  </div>
</template>

<script>
    import Pagination from '@/components/Pagination.vue'
    import AddPage from '@/module/interactionCenter/page/cec/cec/add.vue'
    import UpdatePage from '@/module/interactionCenter/page/cec/cec/update.vue'
    import formatTimeToStr from '@/common/dateFormatUtil.js'
    import api from '@/module/interactionCenter/api/cec.js'
    import interfaceApi from '@/module/interactionCenter/api/interface.js'
    import commonApi from '@/common/api/commonFromVuexApi.js'

    export default {
        data() {
            return {
                addFormVisible: false,
                updateFormVisible: false,
                detailFormVisible: false,
                offVisible: false,
                onVisible: true,
                loading: false, // 是显示加载
                // 选择数据
                selectData: [],
                // 请求数据参数
                formInline: {
                    t: {
                        companyCode: ''
                    }
                },
                // 分页参数
                pageParam: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                },
                // 列表数据
                userData: [],
                // 表单查询条件
                searchData: {
                    yesOrNo: [
                        {value: 'Y', message: this.$t('you-xiao')},
                        {value: 'N', message: this.$t('wu-xiao')}
                    ],
                    interfaceNames: [],
                    stations: [],
                },

                // 选中列数据
                selectRowData: {}
            }
        },
        // 注册组件
        components: {
            AddPage,
            Pagination,
            UpdatePage
        },
        created() {
            this.search()
            this.getInterfaceNames()
            this.getStations()
        },
        filters: {
          formatDateFilter(date) {
              return formatTimeToStr(date, 'yyyy-MM-dd')
          }
        },
        watch: {},
        methods: {
            // 获取接口信息
            getInterfaceNames() {
                interfaceApi.getInterfaceNames().then((res) => {
                    if (res.data != null && res.data.length > 0) {
                        this.searchData.interfaceNames = res.data
                    }
                })
            },
            // 获取站点
            getStations() {
                commonApi.getStations().then((res) => {
                    this.searchData.stations = res
                })
            },
            YesNoFormat(row) {
                if (row.isAvailable === 'Y') {
                    return this.$t('you-xiao-0')
                } else if (row.isAvailable === 'N') {
                    return this.$t('wu-xiao-0')
                }
            },
            handleDelete(index, row) {
                if (!row) {
                    return
                }
                    this.$confirm(this.$t('ci-cao-zuo-jiang-yong-jiu-shan-chu-gai-ji-lu-shi-fou-ji-xu'), this.$t('deviceControl.prompt'), {
                        confirmButtonText: this.$t('deviceControl.confirm'),
                        cancelButtonText: this.$t('alaramMonitor.cancel'),
                        type: 'warning'
                    }).then(() => {
                        api.deleteCecById(row.id).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: this.$t('shan-chu-cheng-gong-0')
                                });
                                this.search()
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('yi-qu-xiao-shan-chu')
                        })
                    })
            },
            // 获取数据方法
            getData(parameter) {
                this.loading = true
                api.getCompanyInfos(JSON.stringify(parameter)).then((res) => {
                    this.userData = res.data.list
                    // 分页赋值
                    this.pageParam.currentPage = res.data.pageNum
                    this.pageParam.total = res.data.total

                    // 加载结束
                    this.loading = false
                }).catch(error => {
                    this.loading = false
                })
            },
            // 分页插件事件
            callFather() {
                let data = {
                    currentPage: this.pageParam.currentPage,
                    pageSize: this.pageParam.pageSize,
                    t: this.formInline.t
                }
                this.getData(data)
            },
            resetSearchForm() {
                this.formInline.t = {}
                this.search()
            },
            // 搜索事件
            search() {
                this.getData(this.formInline)
            },
            // 显示详情界面
            handleDetail: function (index, row) {
                if (row !== undefined) {
                    this.selectRowData = row
                    this.detailFormVisible = true
                }
            },
            // 显示编辑界面
            handleEdit: function (index, row) {
                if (row !== undefined) {
                    this.selectRowData = row
                    this.updateFormVisible = true
                }
            },
            synchronizeData: function (index, row) {
              this.$confirm(this.$t('que-ren-ti-jiao-cao-zuo'), this.$t('deviceControl.prompt'), {
                confirmButtonText: this.$t('deviceControl.confirm'),
                cancelButtonText: this.$t('alaramMonitor.cancel'),
                type: 'warning'
              }).then(() => {
                if (row !== undefined) {
                  let params = {
                    "customerOperatorID": row.companyCode,
                    "equipmentOperatorID": row.operatorid,
                    "pageNo": 1,
                    "pageSize": 5
                  }
                  console.log("params:"+params)
                  this.loading = true
                  api.synchronStationsInfo(params).then((res) => {
                    if (res.code === 0) {
                      this.$message({
                        type: 'success',
                        message: this.$t('cheng-gong')
                      })
                      this.$emit('afterAdd')
                    } else {
                      this.$message.error(res.message)
                    }
                  }).finally(() => {
                    this.loading = false
                  })
                }
              }).catch(() => {})
            },
            // 添加
            handleAdd: function () {
                this.addFormVisible = true
            },
            // 选择复选框事件
            selectChange(val) {
                this.selectData = val
            },
            // 更新成功之后的操作
            afterUpdate() {
                this.updateFormVisible = false
                this.callFather()
            },
            // 添加成功后操作
            afterAdd() {
                this.addFormVisible = false
                this.search()
            },
            // 关闭弹框
            closeDialog(type) {
                console.log('type:' + type)
                if (type === 'update') {
                    this.updateFormVisible = false
                } else if (type === 'add') {
                    this.addFormVisible = false
                } else if (type === 'detail') {
                    this.detailFormVisible = false
                }
            },
            // 获取运营商
            getOperators() {
                commonApi.getOperators().then((res) => {
                    this.searchData.operators = res
                })
            },
          // 运营商审核
          handleSwitch: function (index, row) {
            let operatorInfo = this.userData[index]
              this.$confirm(this.$t('que-ren-xiu-gai-yun-ying-shang-zhuang-tai'), this.$t('deviceControl.prompt'), {
                confirmButtonText: this.$t('deviceControl.confirm'),
                cancelButtonText: this.$t('alaramMonitor.cancel'),
                type: 'warning'
              }).then(() => {
                let param = {
                  id: operatorInfo.id,
                  isAvailable: operatorInfo.isAvailable.code
                }
                api.availableSwitch(param).then(res => {
                  console.log("修改成功：" + operatorInfo.isAvailable.code)
                  // 直接更新列表，就不重新拿数据了
                  if (operatorInfo.isAvailable.code == 'N') {
                    this.userData[index].isAvailable.code = 'Y'
                    this.userData[index].isAvailable.message = this.$t('shi')
                  } else {
                    this.userData[index].isAvailable.code = 'N'
                    this.userData[index].isAvailable.message = this.$t('fou')
                  }
                  this.$message({type: 'success', message: this.$t('cao-zuo-cheng-gong')});
                 })
              }).catch(() => {

              })
          },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/interactionCenter/page/cec/cec/list.vue